import { Avatar, Button, List } from "antd";
import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { OrganisationUsers, ProjectMemberApi } from "../../../api";
import styles from "./add-member.module.css";

const AddMemberCard = (props) => {
  const [members, setMembers] = React.useState([]);
  const [totalMembers, setTotalMembers] = React.useState([]);
  const [toAddMembers, setToAddMembers] = React.useState([]);

  const fetchMembers = (params = {}) => {
    return axios
      .get(`${ProjectMemberApi}`, { params: { ...params } })
      .then((res) => {
        const arr = res.data;
        setMembers(arr);
        return arr;
      });
  };

  const fetchTotalMembers = (id) => {
    return axios
      .get(`${OrganisationUsers}`, { params: { user__is_active: true } })
      .then((res) => {
        const arr = res.data?.filter((each) => !id.includes(each.id));
        setTotalMembers(arr);
        return arr;
      });
  };

  React.useEffect(() => {
    (async () => {
      const members = await fetchMembers({
        project: props.settings.project.id,
      });
      const id = members.map((each) => {
        return each?.user_organisation?.id;
      });
      await fetchTotalMembers(id);
    })();
  }, [props.settings.project.id]);

  const toggleAddMember = (member) => {
    console.log("adding,member>>>", member);
    if (toAddMembers.includes(member?.id)) {
      console.log("adding,member>>>", "a");
      setToAddMembers(toAddMembers.filter((id) => id !== member?.id));
    } else {
      console.log("adding,member>>>", "b");
      setToAddMembers([...toAddMembers, member?.id]);
    }
  };

  const selectAllMembers = () => {
    setToAddMembers(totalMembers.map((each) => each?.id));
  };

  const submitMembers = async () => {
    if (toAddMembers.length === 0) {
      return;
    }

    const data = toAddMembers.map((id) => {
      return {
        user_organisation: id,
        project: props.settings.project.id,
        status: true,
      };
    });

    try {
      await axios.post(`${ProjectMemberApi}`, data);
      toast.success("Members added successfully");
      props.onClose();
    } catch (e) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div className={styles.container}>
      <p>
        There are no members in this project yet. Add members to start working
      </p>
      <div className={styles.selectAllContainer}>
        <Button onClick={selectAllMembers}>Select All</Button>
      </div>
      <section className={styles.list}>
        {totalMembers.map((member) => (
          <div
            className={`${styles.item} ${
              toAddMembers.includes(member?.id) && styles.selected
            }`}
            key={member?.id}
            onClick={() => toggleAddMember(member)}
          >
            <Avatar src={member?.user?.avatar} />
            <div className={styles.details}>
              <div className={styles.name}>{member?.user?.name}</div>
              <div className={styles.description}>
                {member?.user?.email}, {member?.user?.department} -{" "}
                {member?.user?.designation}
              </div>
            </div>
          </div>
        ))}
      </section>
      <section className={styles.actionContainer}>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          type="primary"
          onClick={submitMembers}
          disabled={toAddMembers.length === 0}
        >
          Add {toAddMembers.length !== 0 && toAddMembers.length} Members
        </Button>
      </section>
    </div>
  );
};

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

export default connect(mapStateToProps)(AddMemberCard);
